import { legacy_createStore as createStore, applyMiddleware, type AnyAction } from 'redux';
import {thunk, type ThunkDispatch } from 'redux-thunk';
import EcommerceReducer from './reducers';

let middlewares: any[] = [thunk];

const middlewareEnhancer = applyMiddleware(...middlewares);
const store = createStore(EcommerceReducer, middlewareEnhancer);


export type RootState = ReturnType<typeof EcommerceReducer>;
export type AppDispatch = ThunkDispatch<RootState, any, AnyAction>;

export default store;